<template>
  <TemplateLogin>
    <div
      v-if="loading"
      class="calico-loader-container"
    >
      <CalicoLoader />
    </div>
    <div
      v-else
      class="email-info"
    >
      <i class="bi bi-patch-check-fill" />
      <h3 class="heading--medium">
        Verify your email
      </h3>
      <p class="body--medium">
        A verification link has been sent to your email. Verify your email to access your BetaScore dashboard. The link
        will expire in {{ parseMsToWord(expiryDuration) }}.
      </p>
      <hr class="line">
      <p class="body--medium">
        If you haven't received an email in {{ parseMsToWord(retryDuration) }}, check your spam folder or click the button
        below.
      </p>
      <div class="timer">
        <button
          class="button-primary"
          :disabled="parseTimeToMs(timer)"
          @click="sendOobCode(retryDuration)"
        >
          Resend Verification
        </button>
        <p
          v-if="parseTimeToMs(timer) > 0"
          class="label--small"
        >
          {{ timer }}
        </p>
      </div>
    </div>
  </TemplateLogin>
</template>

<script>
import CalicoLoader from "@/components/calico/loader/index.vue";
import TemplateLogin from "@/components/template/login/index.vue";
import { signOut } from "firebase/auth";
import { RoutesEnum } from "@/enums";
import { countDown } from "@/utils/countdown";
import Auth from "@/services/auth";
import { parseMsToWord, parseTimeToMs } from "@/utils/helper";

export default {
  name: "CalicoVerifyEmailScreen",
  components: { TemplateLogin, CalicoLoader },
  data() {
    return {
      loading: true,
      timer: '00:00',
      expiryDuration: 0,
      retryDuration: 0,
      oobCode: null,

    }
  },
  async mounted() {
    const { exists, retry, duration } = await Auth.oobcode.status(this.$auth.currentUser?.email);
    await this.sendOobCode(retry.countdown, exists);
    this.expiryDuration = duration
    this.retryDuration = retry.duration
    this.loading = false
  },
  methods: {
    parseMsToWord,
    parseTimeToMs,
    async sendOobCode(duration, exists) {
      if (!exists) {
        await Auth.sendVerificationEmail(this.$auth.currentUser?.email);
      }
      countDown({
        duration,
        tickCallback: ({ timer }) => {
        const msLeft = this.parseTimeToMs(timer);
        this.timer = msLeft <= 0 ? '00:00' : timer;
      },
      });
    },
    async back() {
      await signOut(this.$auth);
      this.$router.push(RoutesEnum.LOGIN);
    },
  },
};
</script>

<style scoped lang="scss">
.email-info {
  @include stack-space($space-large);
  max-width: $tablet-breakpoint-min-width;
  padding: $space-large $space-none;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;

  h3 {
    margin: 0;
  }

  p {
    margin: 0;
  }

  hr {
    border: 1px solid $color-border-primary;
    width: 100%;
  }

  .bi {
    font-size: $icon-large;
    color: $color-lapis;
  }

  .timer {
    @include stack-space($space-small);

    .button-primary {
      width: auto;
      padding: 7.5px $space-medium;
    }

    .button-primary:disabled {
      background-color: $color-neutral-light;
      color: $color-neutral-dark;
      cursor: default;
    }

    .label--small {
      color: $color-text-secondary;
      font-weight: 400;
    }
  }
}

.calico-loader-container {
  @include inline-space($space-none);
  justify-content: center;
  align-items: center;
  height: 20vw;
}
</style>
